import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { HistoryService } from './history.service';
import { LookupDetail } from '../models/lookup-detail.model';
import { LookupService } from './lookup.service';
import { LookupCriteria } from '../models/lookup.criteria';


@Injectable({ providedIn: 'root' })
export class LookupListResolver implements Resolve<HttpResponse<LookupDetail[]>> {
  constructor(
    private lookupService: LookupService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    const type = route.params.type;

    return this.lookupService.get(new LookupCriteria().paramsExport(), type);
  }
}
